export default __webpack_public_path__ + "static/media/legal-team-defendant.fd41e532.png";